module.exports = __webpack_public_path__ + "media/music/bass_0-78aaa3f5.mp3";